import { getRequest, checkStatus, parseStatusAndBody } from "helpers/requests";
import { transformUser, ITransformedUser } from "helpers/transforms/user";

import { IUser } from "types/user";
import { HQ_SERVICE } from "constants/app";

function getUser(): Promise<ITransformedUser> {
  return fetch(`${HQ_SERVICE}/user.json`, getRequest())
    .then(response => parseStatusAndBody<IUser>(response))
    .then((parsedResponse: [number, IUser]) =>
      checkStatus<IUser>(parsedResponse)
    )
    .then(transformUser);
}

export { getUser };
